/* eslint-disable @typescript-eslint/naming-convention */
import { ModelValidationMetadataMap } from 'app/core/validation';

export const billValidationMetadata: ModelValidationMetadataMap = {
  Bill: {
    properties: {
      id: {
        required: true,
        displayName: 'Invoice ID'
      },
      invoiceDate: {
        required: true,
        displayName: 'Issue Date',
        validators: [
          {
            name: 'expression',
            context: {
              expression: '!context.isPeriodLocked(context.value)',
              messageTemplate: 'Billing is locked for period ending on %lockedDate%'
            }
          }
        ]
      },
      counterpartyId: {
        required: true,
        displayName: 'Invoice For'
      },
      notes: {
        maxLength: 2000,
        displayName: 'Notes'
      }
    }
  },
  BillDetail: {
    properties: {
      billedUnits: {
        displayName: 'Units',
        validators: [
          {
            name: 'numeric',
            context: {
              allowDecimals: true
            }
          }
        ]
      },
      billedRate: {
        displayName: 'Rate',
        validators: ['currency']
      },
      billedTotal: {
        required: true,
        displayName: 'This Bill',
        validators: ['currency']
      },
      writeOffTotal: {
        displayName: 'W/Off',
        validators: ['currency']
      },
      billMemo: {
        maxLength: 2000,
        displayName: 'Memo'
      },
      timeCategory1Id: {
        displayName: 'Category 1',
        validators: [{
          name: 'required',
          condition: 'model.timeEntryTypeId === 3'
        }]
      }
    }
  }
};
